import { TablePlaceFilterInput } from 'common/inputs/TablePlaceFilterInput'
import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Category, Place, TowelVariant } from 'types/products'
import { useTableWithProduct, VariantWithProduct } from './useTableWithProduct'

export function TowelTableWithProduct() {
  const columns = useMemo<Array<MRT_ColumnDef<VariantWithProduct<TowelVariant>>>>(
    () => [
      {
        accessorKey: 'product.symbol',
        header: 'Produkt',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po symbolu',
        },
      },
      {
        accessorKey: 'size',
        header: 'Wymiar',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wymiarze',
        },
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        Filter: TablePlaceFilterInput,
      },
      {
        accessorKey: 'feature',
        header: 'Cecha',
        enableSorting: false,
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po cesze',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )

  const table = useTableWithProduct({
    category: Category.TOWEL,
    columns,
  })

  return <MantineReactTable table={table} />
}
